import React from "react";
import { Box } from "@mui/material";
import { NodeRepeatableList, NodeTextField } from "../../../../NodeUI";
import AgentConfigSection from "../../AgentConfigSection";

export default function ExamplePromptsSection({
  examplePrompts,
  setExamplePrompts,
  isSystemAgent,
}) {
  return (
    <AgentConfigSection id="examplePrompts">
      <Box sx={{ mb: 2.5 }}>
        <NodeRepeatableList
          items={examplePrompts}
          onItemsChange={setExamplePrompts}
          createItem={() => ({ title: "", prompt: "" })}
          addLabel="Add example prompt"
          maxItems={6}
          emptyMessage="No example prompts configured."
          disabled={isSystemAgent}
          renderItem={(item, index, { updateItem }) => (
            <>
              <NodeTextField
                label="Card title"
                value={item.title || ""}
                placeholder="Short label shown on the card"
                disabled={isSystemAgent}
                onChange={(value) => updateItem(index, { ...item, title: value })}
              />
              <NodeTextField
                label="Prompt inserted into chat"
                value={item.prompt || ""}
                placeholder="Text inserted when the card is clicked"
                disabled={isSystemAgent}
                multiline
                minRows={2}
                onChange={(value) =>
                  updateItem(index, { ...item, prompt: value })
                }
              />
            </>
          )}
        />
      </Box>
    </AgentConfigSection>
  );
}
